
import _forEach from 'lodash/forEach'

const form = new Vue({
    el: '#castanyada_form',
    data() {
        return {
            form: {
                name: '',
                phone: '',
                email: '',
                street: '',
                number: '',
                municipality: '',
                terms: false,
            },
            default: {
                name: '',
                phone: '',
                email: '',
                street: '',
                number: '',
                municipality: '',
                terms: false,
            },
            validation: {
                name: 'required',
                phone: 'required',
                email: 'required',
                street: 'required',
                number: 'required',
                municipality: 'required',
            },
            errors: {
                name: false,
                phone: false,
                email: false,
                street: false,
                number: false,
                municipality: false,
                terms: false,
            },
        }
    },
    methods: {
        validateInputs() {
            let hasErrors = false;
            _forEach(this.validation, (field, key) => {
                this.errors[key] = false
                if(key === 'phone'){
                    var phoneRGEX = /^[0-9]{9}$/;
                    var phoneResult = phoneRGEX.test(this.form[key]);
                    if(!phoneResult){
                        this.errors[key] = true;
                        hasErrors = true
                    }
                }

                if(key === 'email'){
                    var emailRGEX = /^.+@.+$/;
                    var emailResult = emailRGEX.test(this.form[key]);
                    if(!emailResult){
                        this.errors[key] = true;
                        hasErrors = true
                    }
                }

                if(!this.form[key].length){
                    this.errors[key] = true
                    hasErrors = true
                }
            })
            this.errors.terms = false
            if(!this.form.terms){
                console.log('error terms');
                this.errors.terms = true
                hasErrors = true
            }
            if(hasErrors)
                return false

            return true
        },

        submit(){
            if(!this.validateInputs()){
                return false
            }
            $("#castanyada_form").submit();
        }
    }
});

